<template>
    <el-dialog
            :visible.sync="showModel"
            :modal="isModal"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :modalAppendToBody="false"
            top="40%"
            width="80%"
            custom-class="commDialog">

        <div class="container">
            <img :src="icon" class="icon">
            <div v-html="outerContent" class="outer-content"/>
            <div v-html="outerContentBody" class="main-content"></div>
            <span>{{outerContent2}}</span>
            <div slot="footer" class="dialog-footer">
                <el-button @click="trash" round v-show="isCancel" type="info">{{negativeLabel}}</el-button>
                <el-button @click="confirm" round type="primary">{{positiveLabel}}</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "CommDialog",
        props: {
            icon: {default: require('@/assets/images/dialog_question.svg')},
            outerContent: {default: "提醒"},
            outerContentBody:{default:""},
            outerContent2:{default:"0000-00-00 00:00:00"},
            positiveLabel: {default: "確定"},
            negativeLabel: {default: "刪除"},
            value: {required: false, type: Boolean, default: false},        //是否顯示 dialog (dialog開關)?
            eventType: {required: false, type: Number, default: 0},            //事件種類辨認用，會在 result 中回傳，可以在顯示 dialog前設定好，在 result中以此來辨認目前是哪個事件的 result
            isCancel: {default: true},
            isModal: {default: true},
            outerId:{default: ''},
        },
        data() {
            return {
                showModel: this.value,
            }
        },
        created() {

        },
        mounted() {

        },
        watch: {
            value: function () {
                this.showModel = this.value;
            }
        },
        methods: {
            trash: function () {
                this.showModel = false;
                //回傳 result，外部接收到 result事件後再做處理
                // args1 : 是否確定？
                // args2 : 事件類型
                this.$emit('result', 'delete', this.outerId);
            },
            confirm: function () {
                this.showModel = false;
                //回傳 result，外部接收到 result事件後再做處理
                this.$emit('result', 'read', this.outerId);
            }
        }
    }
</script>

<style lang="less" scoped>

</style>

